var map = {
  "./applications.json": "58831",
  "./apps.json": "32744",
  "./attachment_relations.json": "41279",
  "./boarding.json": "34168",
  "./calendar.json": "60354",
  "./common.json": "63077",
  "./customizable_table.json": "80099",
  "./dashboard.json": "31596",
  "./job_ads.json": "58354",
  "./layouts.json": "64607",
  "./mailer.json": "84364",
  "./modules.json": "27085",
  "./news.json": "12087",
  "./payments.json": "34479",
  "./permission_presets.json": "96612",
  "./posting_orders.json": "18718",
  "./search.json": "79212",
  "./skills.json": "36318",
  "./statistics.json": "35811",
  "./support.json": "60527",
  "./time_tracking.json": "66135",
  "./wizard_settings.json": "28329"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 19089;
